import { useRouter } from "next/navigation";

import LabelButtonWrapper from "@/components/atoms/button-wrapper/button-wrapper";
import { TravellerEdit } from "@/config/app-constant";
import useGtmCustomEvent from "@/hooks/gtm/use-gtm-custom-events";
import { useRenewalStateContext } from "@/providers/renewal-state-provider";

type TravellersDetailsProps = {
  typeNameAge: string;
  editCtaLabel: string;
  id: string;
};

function TravellersDetailsRow(props: Readonly<TravellersDetailsProps>) {
  const router = useRouter();
  const { typeNameAge, editCtaLabel, id } = props;
  const { updateLastEditAccordion } = useRenewalStateContext();

  const handleGtmEvent = useGtmCustomEvent({
    event: "custom_events",
    eventName: "edit_cta",
    quoteSection: "travellers",
  });

  return (
    <div className="flex justify-between items-start">
      <div>
        <p className="font-body-font text-xs font-[700] leading-[27px] text-interactive-secondary-default">
          {typeNameAge}
        </p>
      </div>
      <div className="h-[18px]">
        <LabelButtonWrapper
          label={editCtaLabel}
          hierarchy="tertiary"
          className="font-body-font leading-[18px] font-[600] text-xs py-spacing-xxs top-[-2px] !px-spacing-xxs ml-spacing-m"
          id={id}
          onClick={() => {
            updateLastEditAccordion("travellers");
            handleGtmEvent();
            router.push(`/cover-for?${TravellerEdit}=true`);
          }}
        />
      </div>
    </div>
  );
}

export default TravellersDetailsRow;
